import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { LocalizationProvider } from "@mui/lab";
import { Stack, TextField } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import axios from "axios";
import moment from "moment";
import Multiselect from "multiselect-react-dropdown";
import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import { useHistory, useParams } from "react-router-dom";
import swal from "sweetalert";
import cup from "../../../assets/images/page 1.png";
import "./AuditionRounds.css";

import { Nav, Tab } from "react-bootstrap";

import Loader from "../../Pages/Errors/Loader";
import ReUseableSingleRoundTab from "../../Reuseable/ReUseableSingleRoundTab";
import { serverInfo } from "../../../App";
import { useContext } from "react";

const AuditiionRoundInstruction = () => {
  const { imageCdnUrl,videoCdnUrl } = useContext(serverInfo);
  const { slug } = useParams();
  const [loading, setLoading] = useState(true);
  const [isEditShow, setIsEditShow] = useState(false);
  const [activeRound, setActiveRound] = React.useState(0);
  const [file, setFile] = useState("");
  const [imageData, setImageData] = useState("");
  const [fileVideo, setFileVideo] = useState("");
  const [filePdf, setFilePdf] = useState("");
  const [videoFile, setVideoFile] = useState("");
  const [event, setEvent] = useState({});
  const [judges, setJudges] = useState([]);
  const [convertedContent, setConvertedContent] = useState(null);
  const [errorList, setErrorList] = useState([]);
  const [submit, setSubmit] = useState(false);
  const [rounds, setRounds] = useState([]);

  const [value, setValue] = React.useState(new Date());

  const [items, setItems] = useState([]);

  const history = useHistory();

  const getRoundInstruction = () => {
    setLoading(true);
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios
        .get(
          `/api/audition-admin/audition/get-round-instruction/${event.id}/${activeRound}`
        )
        .then((res) => {
          if (res.data.status === 200) {
            if (res.data.auditon_round_instruction == null) {
              let judges_array = [];
              setIsEditShow(false);
              setFile("");
              setVideoFile("");
              setConvertedContent("");
              setItems([]);
              setValue(new Date());

              res.data.event?.assigned_judges?.forEach((judge) => {
                let user = judge?.user;
                judges_array.push({
                  name: user.first_name + " " + user.last_name,
                  id: user.id,
                });
              });
              setJudges(judges_array);
            } else {
              setIsEditShow(true);
              setFile(imageCdnUrl + res.data.auditon_round_instruction.image);
              setVideoFile(
                videoCdnUrl + res.data.auditon_round_instruction.video
              );
              setConvertedContent(
                res.data.auditon_round_instruction.instruction
              );
              setValue(
                new Date(res.data.auditon_round_instruction.submission_end_date)
              );

              let seleted_judges_array = [];

              res.data.auditon_round_instruction?.instruction_send_infos?.forEach(
                (judge, index) => {
                  let user = judge?.star;
                  seleted_judges_array.push({
                    name: user.first_name + " " + user.last_name,
                    id: user.id,
                  });
                }
              );
              setItems(seleted_judges_array);
            }
          }
          setLoading(false);
        });
    });
  };

  const fetchAuditionDetails = () => {
    axios.get(`/api/audition-admin/audition-event/for-round-instruction/${slug}`).then((res) => {
      if (res.data.status === 200) {
        let judges_array = [];
        setEvent(res.data.event);
        setActiveRound(res.data.event.active_round_info_id);

        setRounds(res.data.event?.info?.audition_rounds);

        res.data.event.assigned_judges.forEach((judge, index) => {
          let user = judge?.user;
          judges_array.push({
            name: user.first_name + " " + user.last_name,
            id: user.id,
          });
        });
        setJudges(judges_array);
      }
    });
  };

  useEffect(() => {
    getRoundInstruction();
  }, [activeRound]);

  useEffect(() => {
    fetchAuditionDetails();
  }, [slug]);

  const handleImageChange = (file) => {
    setFile(URL.createObjectURL(file[0]));
    setImageData(file[0]);
  };
  const handleVideoChange = (file) => {
    setFileVideo(file[0]);
    setVideoFile(URL.createObjectURL(file[0]));
  };

  const handlePdfChange = (file) => {
    setFilePdf(file[0]);
  };

  const handleSelect = (selectedList) => {
    setItems(selectedList);
  };

  const handleRemove = (selectedList) => {
    setItems(selectedList);
  };

  const submitRoundInstruction = (e) => {
    e.preventDefault();
    setSubmit(true);
    const fData = new FormData();
    fData.append("audition_id", event.id);
    fData.append("round_info_id", activeRound);
    if (items.length > 0) {
      items.forEach((item) => {
        fData.append("star_ids[]", Number(item.id));
      });
    }
    fData.append("instruction", convertedContent);
    fData.append("video", fileVideo);
    fData.append("image", imageData);
    fData.append("pdf", filePdf);
    fData.append("submission_date", moment(value).format("YYYY-MM-DD"));

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios
        .post(`/api/audition-admin/audition/round-instruction/store`, fData)
        .then((res) => {
          setSubmit(false);
          if (res.data.status === 200) {
            swal("Success", res.data.message, "success");
            history.goBack();
          } else {
            setErrorList(res.data.validation_errors);
          }
        });
    });
  };

  return (
    <>
      {loading === true ? (
        <>
          <Loader />
        </>
      ) : (
        <>
          <Tab.Container id="left-tabs-example" defaultActiveKey={activeRound}>
            <div className="container-lg">
              <Nav variant="pills">
                <div className="row">
                  {rounds &&
                    rounds.map((auditionRound, index) => (
                      <ReUseableSingleRoundTab
                        key={index}
                        auditionRound={auditionRound}
                        setActiveRound={setActiveRound}
                      />
                    ))}
                </div>
              </Nav>
              <div className="my-4"></div>
            </div>
          </Tab.Container>

          {isEditShow ? (
            <>
              <div className="d-flex justify-content-center card-bg head-line mb-2">
                <div className="text-light d-flex p-2">
                  <div className="faTrophy">
                    <img src={cup} alt="" width="30px" />
                  </div>
                  <h4 className="mx-3 text-white p-2">
                    Edit Round Instruction for Star
                  </h4>
                </div>
              </div>

              <div className="card card-bg mb-2 p-2 ">
                <div className="card card-bg m-2">
                  <div className="container-lg">
                    <div className="row">
                      <div className="clo-sm-12 col-md-12 col-lg-9 mx-auto">
                        <form
                          onSubmit={submitRoundInstruction}
                          id="input_form"
                          encType="multipart/form-data"
                        >
                          <div className="row ms-5">
                            <div className="form-group row mt-3">
                              <label
                                for="staticEmail"
                                className="col-sm-3 label-text "
                              >
                                Post Title
                              </label>
                              <div className="col-sm-9">
                                <input
                                  type="text"
                                  className="form-control reply-control"
                                  value={event.title}
                                  readOnly
                                />
                              </div>
                            </div>

                            <div className="form-group row mt-3">
                              <label
                                for="inputPassword"
                                className="col-sm-3 label-text  "
                              >
                                Instruction
                              </label>
                              <div className="col-sm-9">
                                <CKEditor
                                  editor={ClassicEditor}
                                  data={convertedContent}
                                  onChange={(event, editor) => {
                                    const data = editor.getData();
                                    setConvertedContent(data);
                                  }}
                                />
                                <span className="text-danger">
                                  {errorList.instruction}
                                </span>
                              </div>
                            </div>

                            <div className="form-group row mt-3">
                              <label
                                for="staticEmail"
                                className="col-sm-3 label-text  "
                              >
                                Select Superstar
                              </label>
                              <div className="col-sm-9">
                                <Multiselect
                                  options={judges}
                                  selectedValues={items}
                                  onSelect={handleSelect}
                                  onRemove={handleRemove}
                                  displayValue="name"
                                  className="reply-control"
                                />
                                <span className="text-danger">
                                  {errorList.star_ids}
                                </span>
                              </div>
                            </div>

                            <div className="form-group row mt-3">
                              <label
                                for="staticEmail"
                                className="col-sm-3 label-text "
                              >
                                Upload Video
                              </label>
                              <div className="col-md-3 mb-3">
                                {videoFile ? (
                                  <>
                                    <ReactPlayer
                                      url={videoFile}
                                      className="width-img"
                                      controls={true}
                                      style={{
                                        width: "100%",
                                        maxHeight: "150px",
                                      }}
                                    />
                                  </>
                                ) : (
                                  <></>
                                )}
                                <input
                                  type="file"
                                  name="file"
                                  id="setFile"
                                  className="inputfile w-25"
                                  accept="video/mp4"
                                  onChange={(e) =>
                                    handleVideoChange(e.target.files)
                                  }
                                />

                                <label for="setFile">
                                  <i className="fas fa-cloud-upload-alt"></i>{" "}
                                  Upload Video
                                </label>
                                <span className="text-danger">
                                  {errorList.video}
                                </span>
                              </div>

                              <label
                                for="staticEmail"
                                className="col-sm-3 label-text text-md-end "
                              >
                                Upload Banner
                              </label>
                              <div className="col-md-3 mb-3">
                                {file ? (
                                  <img
                                    src={file}
                                    alt="..."
                                    className="demo-preview-image img-fluid"
                                    style={{
                                      width: "100%",
                                      maxHeight: "150px",
                                    }}
                                  />
                                ) : (
                                  ""
                                )}
                                <input
                                  type="file"
                                  name="imageFile"
                                  id="imageFile"
                                  className="inputfile w-25"
                                  accept="image/jpg,image/jpeg, image/png"
                                  onChange={(e) =>
                                    handleImageChange(e.target.files)
                                  }
                                />

                                <label for="imageFile">
                                  <i className="fas fa-cloud-upload-alt"></i>{" "}
                                  Upload Banner
                                </label>
                                <span className="text-danger">
                                  {errorList.image}
                                </span>
                              </div>
                            </div>

                            <div className="form-group row mt-3">
                              <label
                                for="staticEmail"
                                className="col-sm-3 label-text "
                              >
                                Instruction PDF
                              </label>
                              <div className="col-md-3 mb-3">
                                <input
                                  type="file"
                                  name="pdfFile"
                                  d="pdfFile"
                                  accept=".pdf"
                                  className="inputfile w-25"
                                  onChange={(e) =>
                                    handlePdfChange(e.target.files)
                                  }
                                />
                                <label for="pdfFile">
                                  <i className="fa-solid fa-file-pdf"></i> 1 MB
                                  Maximum
                                </label>
                              </div>

                              <label
                                for="staticEmail"
                                className="col-sm-3 label-text text-md-end "
                              >
                                Submission Dater
                              </label>
                              <div className="col-md-3 mb-3">
                                <LocalizationProvider
                                  dateAdapter={AdapterDateFns}
                                >
                                  <Stack spacing={3}>
                                    <DatePicker
                                      disablePast
                                      label="Responsive"
                                      openTo="day"
                                      views={["year", "month", "day"]}
                                      value={value}
                                      onChange={(newValue) => {
                                        setValue(newValue);
                                      }}
                                      renderInput={(params) => (
                                        <TextField {...params} />
                                      )}
                                    />
                                  </Stack>
                                </LocalizationProvider>
                                <span className="text-danger">
                                  {errorList.submission_date}
                                </span>
                              </div>
                            </div>

                            {/* Create Submit */}
                            <div className="row justify-content-center aligns-items-center my-4 mt-5">
                              <div className="col-md-3"></div>
                              <div className="col-md-9 d-flex justify-content-center aligns-items-center">
                                {submit ? (
                                  <>
                                    <button className="btn btnCreate">
                                      <i className="fas fa-spinner fa-pulse"></i>{" "}
                                    </button>
                                  </>
                                ) : (
                                  <button
                                    className="btn btnCreate fw-bold"
                                    type="submit"
                                  >
                                    Confirm
                                  </button>
                                )}
                              </div>
                            </div>
                            {/* Create Submit End */}
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="">
                <div className="card card-bg head-line mb-2">
                  <div className="text-light d-flex justify-content-center p-2">
                    <div className="faTrophy">
                      <img src={cup} alt="" className="mt-1" width="30px" />{" "}
                    </div>
                    <h4 className="mx-3 text-warning p-2">
                      Make Instruction Round Instruction for Star
                    </h4>
                  </div>
                </div>
                <div className="card card-bg mb-2 p-2 ">
                  <div className="card card-bg m-2">
                    <div className="container-lg">
                      <div className="row">
                        <div className="clo-sm-12 col-md-12 col-lg-9 mx-auto">
                          <form
                            onSubmit={submitRoundInstruction}
                            id="input_form"
                            encType="multipart/form-data"
                          >
                            <div className="row ms-5">
                              <div className="form-group row mt-3">
                                <label
                                  for="staticEmail"
                                  className="col-sm-3 label-text  "
                                >
                                  Post Title
                                </label>
                                <div className="col-sm-9">
                                  <input
                                    type="text"
                                    className="form-control reply-control"
                                    value={event.title}
                                    readOnly
                                  />
                                </div>
                              </div>

                              <div className="form-group row mt-3">
                                <label
                                  for="inputPassword"
                                  className="col-sm-3 label-text "
                                >
                                  Instruction
                                </label>
                                <div className="col-sm-9">
                                  <CKEditor
                                    editor={ClassicEditor}
                                    data={convertedContent}
                                    onChange={(event, editor) => {
                                      const data = editor.getData();
                                      setConvertedContent(data);
                                    }}
                                  />
                                  <span className="text-danger">
                                    {errorList.instruction}
                                  </span>
                                </div>
                              </div>

                              <div className="form-group row mt-3">
                                <label
                                  for="staticEmail"
                                  className="col-sm-3 label-text  "
                                >
                                  Select Superstar
                                </label>
                                <div className="col-sm-9">
                                  <Multiselect
                                    className="reply-control"
                                    options={judges}
                                    selectedValues={items}
                                    onSelect={handleSelect}
                                    onRemove={handleRemove}
                                    displayValue="name"
                                  />
                                  <span className="text-danger">
                                    {errorList.star_ids}
                                  </span>
                                </div>
                              </div>

                              <div className="form-group row mt-3">
                                <label
                                  for="staticEmail"
                                  className="col-sm-3 label-text"
                                >
                                  Upload Video Instruction For Star
                                </label>

                                <div className="col-md-5">
                                  {videoFile ? (
                                    <>
                                      <ReactPlayer
                                        url={videoFile}
                                        // width="100%"
                                        controls={true}
                                        height="35vh"
                                      />
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                  <input
                                    type="file"
                                    name="file"
                                    id="setFile"
                                    className="inputfile w-25"
                                    accept="video/mp4"
                                    onChange={(e) =>
                                      handleVideoChange(e.target.files)
                                    }
                                  />

                                  <label for="setFile">
                                    <i className="fas fa-cloud-upload-alt"></i>{" "}
                                    Upload Video
                                  </label>
                                  <span className="text-danger">
                                    {errorList.video}
                                  </span>
                                </div>
                              </div>

                              <div className="form-group row mt-3">
                                <label
                                  for="staticEmail"
                                  className="col-sm-3 label-text"
                                >
                                  Upload Image Instruction For Star
                                </label>

                                <div className="col-sm-5">
                                  {file ? (
                                    <img
                                      src={file}
                                      alt="..."
                                      className="demo-preview-image img-fluid"
                                    />
                                  ) : (
                                    ""
                                  )}
                                  <input
                                    type="file"
                                    name="imageFile"
                                    id="imageFile"
                                    className="inputfile w-25"
                                    accept="image/jpg,image/jpeg, image/png"
                                    onChange={(e) =>
                                      handleImageChange(e.target.files)
                                    }
                                  />

                                  <label for="imageFile">
                                    <i className="fas fa-cloud-upload-alt"></i>{" "}
                                    Upload Image
                                  </label>
                                  <span className="text-danger">
                                    {errorList.image}
                                  </span>
                                </div>

                                {/* <div className="col-sm-7 mb-2">
                          <div className="row my-4">
                            {file ? (
                              <img
                                src={file}
                                alt="..."
                                className="demo-preview-image img-fluid"
                              />
                            ) : (
                              ""
                            )}
                            <div className="col-md-10">
                              <input
                                type="file"
                                name="imageFile"
                                id="imageFile"
                                className="inputfile w-25"
                                accept="image/jpg,image/jpeg, image/png"
                                onChange={(e) =>
                                  handleImageChange(e.target.files)
                                }
                              />

                              <label for="imageFile">
                                <i className="fas fa-cloud-upload-alt"></i>{" "}
                                Upload Image
                              </label>
                              <span className="text-danger">
                                {errorList.image}
                              </span>
                            </div>
                          </div>
                        </div> */}
                              </div>

                              <div className="form-group row mt-1">
                                <label
                                  for="staticEmail"
                                  className="col-sm-3 label-text "
                                >
                                  Instruction pdf for the round
                                </label>

                                <div className="col-sm-5 mb-2">
                                  <div className="row d-flex justify-content-start my-4">
                                    <div className="inputeParent">
                                      <input
                                        type="file"
                                        name="pdfFile"
                                        id="pdfFile"
                                        accept=".pdf"
                                        className="inputfile w-25"
                                        onChange={(e) =>
                                          handlePdfChange(e.target.files)
                                        }
                                      />
                                      <label for="pdfFile">
                                        <i className="fa-solid fa-file-pdf"></i>{" "}
                                        1 MB Maximum
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="form-group row mt-1">
                                <label
                                  for="staticEmail"
                                  className="col-sm-3 label-text"
                                >
                                  Instruction Submission Date
                                </label>

                                <div className="col-sm-7 row d-flex justify-content-start mb-2">
                                  <div className="col-md-5 dateParentPicker timeLengthPicker">
                                    <LocalizationProvider
                                      dateAdapter={AdapterDateFns}
                                    >
                                      <Stack spacing={3}>
                                        <DatePicker
                                          disablePast
                                          label="Select Date"
                                          openTo="day"
                                          views={["year", "month", "day"]}
                                          value={value}
                                          onChange={(newValue) => {
                                            setValue(newValue);
                                          }}
                                          renderInput={(params) => (
                                            <TextField {...params} />
                                          )}
                                        />
                                      </Stack>
                                    </LocalizationProvider>
                                    <span className="text-danger">
                                      {errorList.submission_date}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              {/* Create Submit */}
                              <div className="row justify-content-center aligns-items-center my-4 mt-5">
                                <div className="col-md-3"></div>
                                <div className="col-md-9 d-flex justify-content-center aligns-items-center">
                                  {submit ? (
                                    <>
                                      <button className="btn btnCreate">
                                        <i className="fas fa-spinner fa-pulse"></i>{" "}
                                      </button>
                                    </>
                                  ) : (
                                    <button
                                      className="btn btnCreate fw-bold"
                                      type="submit"
                                    >
                                      Confirm
                                    </button>
                                  )}
                                </div>
                              </div>
                              {/* Create Submit End */}
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </>
      )}
    </>
  );
};

export default AuditiionRoundInstruction;
